import React from "react";
import { connect } from "react-redux";
import "./EditArticlePreviewList.css";
import {
  changeArticleModeAction,
  setPreviewOffsetAction
} from "../../redux/actions/editArticlePanel";
import ArticlePreviewTopTitle from "../ArticlePreviewTopTitle/ArticlePreviewTopTitle";
import ArticlePreviewListItem from "../ArticlePreviewListItem/ArticlePreviewListItem";
import ArticlePreviewContributorsItem from "../ArticlePreviewContributorsItem/ArticlePreviewContributorsItem";

class EditArticlePreviewList extends React.Component {
  constructor(props) {
    super(props);
    this.onItemDoubleClicked = this.onItemDoubleClicked.bind(this);

    this.listRef = React.createRef();
  }

  componentDidMount() {
    try {
      this.listRef.parentNode.scrollTop = this.props.previewOffset;
    } catch (e) {
      console.log(e.toString());
    }
  }

  componentWillUnmount() {
    try {
      this.props.setPreviewOffsetAction({
        previewOffset: this.listRef.parentNode.scrollTop
      });
    } catch (e) {
      console.log(e.toString());
    }
  }

  onItemDoubleClicked(item) {
    this.props.changeArticleModeAction({ mode: "edit", lockingID: item.id });
  }

  render() {
    const { article, issue, metaDict, items } = this.props;

    return (
      <div
        className="article_preview_list_container no_move_panel"
        ref={el => (this.listRef = el)}
      >
        <ArticlePreviewTopTitle
          article={article}
          issue={issue}
          metaDict={metaDict}
        />

        {items.map((anItem, index, array) => (
          <div
            key={anItem.id}
            onDoubleClick={() => this.onItemDoubleClicked(anItem)}
          >
            <ArticlePreviewListItem
              item={anItem}
              previousItem={index >= 1 ? array[index - 1] : null}
            />
          </div>
        ))}

        <ArticlePreviewContributorsItem article={article} metaDict={metaDict} />
      </div>
    );
  }
}

const mapState = (state, ownProps) => {
  const { editArticlePanel } = state;
  const {
    contentEditHistory,
    metaEditHistory,
    previewOffset
  } = editArticlePanel;
  const metaDict = metaEditHistory[metaEditHistory.length - 1];

  let items = [];
  if (contentEditHistory.length > 0) {
    let itemIDs = contentEditHistory[contentEditHistory.length - 1].itemIDs;
    let itemsDict = contentEditHistory[contentEditHistory.length - 1].itemsDict;

    items = itemIDs.map(anItemID => itemsDict[anItemID]);
  }

  return {
    items,
    metaDict,
    previewOffset
  };
};

const mapDispatch = {
  changeArticleModeAction,
  setPreviewOffsetAction
};

export default connect(
  mapState,
  mapDispatch
)(EditArticlePreviewList);
